<template>
  <div class="container mx-auto my-8 px-4">
    <div
      v-if="currentUser && currentUser.admin"
      class="flex justify-between mb-4"
    >
      <h1 class="font-bold text-4xl">Posts</h1>
      <Link :href="newPostPath" class="primary-button">New post</Link>
    </div>
    <h1 v-else class="font-bold text-4xl mb-4">Posts</h1>

    <div class="flex flex-col gap-4">
      <div
        v-for="post in posts"
        :key="post.id"
        class="bg-white shadow rounded p-4"
      >
        <p class="text-xl font-bold">
          <Link :href="post.path" class="hover:text-emerald-600">{{
            post.title
          }}</Link>
        </p>
        <p class="mt-2 text-gray-600">{{ post.body }}</p>
      </div>

      <div v-if="posts.length === 0" class="text-lg text-gray-500">
        No posts yet.
      </div>
    </div>
  </div>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";

defineProps({
  posts: { type: Array, default: () => [] },
  currentUser: { type: Object, default: null },
  newPostPath: { type: String, default: "" },
});
</script>
